import Head from 'next/head';
import Pagination from '@/components/Pagination';

const Page = () => {
  return (
    <>
      <Head>
        <title>Pagination</title>
      </Head>

      <h1 className="mt-4">Pagination</h1>
      <Pagination />
    </>
  );
};

export default Page;
